import { Box, ModalFooter } from '@chakra-ui/react';
import * as React from 'react';

export const PostingModalFooter: React.FC = (props) => {
  return (
    <ModalFooter
      bg="gray.50"
      borderBottomRadius="md"
      borderTop="1px"
      borderColor="gray.100"
      px="6"
      py="4"
    >
      {props.children}
    </ModalFooter>
  );
};
